module.exports = __webpack_public_path__ + "static/media/4.1e7b7001.jpeg";